<div class="row">
  <ng-container *ngIf="mandatoryDocuments">
    <ng-container *ngFor="let item of mandatoryDocuments.employeeDocuments">
      <app-id-card *ngIf="item?.name === 'RG'"
                   [isExhibition]="isExhibition"
                   [ufs]="ufs$ | async"
                   [idCardValue]="documentation?.rg"
                   [isConsult]="isConsult"
                   (formValue)="getIdCardValue($event)"
                   (downloadEvent)="downloadEventHandler($event)">
      </app-id-card>

      <app-cpf *ngIf="item?.name === 'CPF'"
               [isExhibition]="isExhibition"
               [cpfValue]="documentation?.cpf"
               [isConsult]="isConsult"
               (formValue)="getCpfValue($event)"
               (downlaodEvent)="downloadEventHandler($event)">
      </app-cpf>

      <app-work-card *ngIf="item?.name === 'CTPS'"
                     [isExhibition]="isExhibition"
                     [ufs]="ufs$ | async"
                     [ctps]="documentation?.ctps"
                     [isConsult]="isConsult"
                     (formValue)="getWorkCardfValue($event)"
                     (downloadEvent)="downloadEventHandler($event)">
      </app-work-card>

      <app-birth-marriage-certificate *ngIf="item?.name === 'CERTIDAO_CASAMENTO_NASCIMENTO'"
                                      [isExhibition]="isExhibition"
                                      [birthCertificate]="documentation?.birthCertificate"
                                      [birthCertificateExtension]="documentation?.birthCertificateExtension"
                                      [isConsult]="isConsult"
                                      (birthCertificateDocumentValue)="getBirthMarriageCertificateDoc($event)"
                                      (downloadEvent)="downloadEventHandler($event)">
      </app-birth-marriage-certificate>

      <app-voter-registration *ngIf="item?.name === 'TITULO_ELEITOR'"
                              [isExhibition]="isExhibition"
                              [ufs]="ufs$ | async"
                              [voter]="documentation?.voter"
                              [isConsult]="isConsult"
                              (formValue)="getVoterRegistration($event)"
                              (downloadEvent)="downloadEventHandler($event)">
      </app-voter-registration>

      <app-proof-residence *ngIf="item?.name === 'COMPROVANTE_RESIDENCIA'"
                           [isExhibition]="isExhibition"
                           [addressProofDocument]="documentation?.addressProofDocument"
                           [addressProofDocumentExtension]="
          documentation?.addressProofDocumentExtension
        "
                           [isConsult]="isConsult"
                           (formValue)="getAddressProofDocument($event)"
                           (downloadEvent)="downloadEventHandler($event)">
      </app-proof-residence>

      <app-work-job-contract *ngIf="item?.name === 'CONTRATO_TRABALHO'"
                             [isExhibition]="isExhibition"
                             [workJobContracts]="documentation?.workJobContracts"
                             [contractRemovedId]="contractRemovedId"
                             [isConsult]="isConsult"
                             (SaveContract)="getSaveWorkJobContract($event)"
                             (DeleteContract)="deletetWorkJobContract($event)">
      </app-work-job-contract>

      <app-academic-education *ngIf="item?.name === 'FORMACAO_ACADEMICA'"
                              [isExhibition]="isExhibition"
                              [academicEducation]="documentation?.academicEducation"
                              [schoolRemovedId]="schoolRemovedId"
                              [isConsult]="isConsult"
                              (SaveSchool)="getSaveSchool($event)"
                              (DeleteSchoolValue)="deleteSchool($event)"
                              (downloadEvent)="downloadEventHandler($event)">
      </app-academic-education>

      <app-generic-document *ngIf="canShowGenericDocument(item?.name)"
                            [mandatoryDocumentItem]="item"
                            [isExhibition]="isExhibition"
                            [genericDocumentValue]="
          getMandatoryDocumentValue(documentation?.mandatoryDocuments, item)
        "
                            [isConsult]="isConsult"
                            (formValue)="AddGenericDocument.emit($event)"
                            (downloadEvent)="downloadEventHandler($event)">
      </app-generic-document>
    </ng-container>
  </ng-container>

  <hr class="w-100 border-bottom my-5" />

  <div class="col-md-12 row justify-content-end my-">
    <div class="col-md-4 text-align-end"
         *ngIf="!isContributorProfile">
      <button type="submit"
              class="btn btn-outline-secondary m-1 text-uppercase"
              (click)="logoutEmit()">
        salvar e sair
      </button>

      <button class="btn btn-secondary text-uppercase"
              type="button"
              (click)="back.emit()">
        Voltar
      </button>

      <button type="submit"
              class="btn btn-primary m-1 text-uppercase"
              (click)="next.emit(2)">
        Salvar e avançar
      </button>
    </div>
  </div>
</div>